import { render, staticRenderFns } from "./productcolor.vue?vue&type=template&id=6550457a&scoped=true&"
import script from "./productcolor.vue?vue&type=script&lang=js&"
export * from "./productcolor.vue?vue&type=script&lang=js&"
import style0 from "./productcolor.vue?vue&type=style&index=0&id=6550457a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6550457a",
  null
  
)

export default component.exports